import emptyStateImage from 'assets/images/common/empty_state.png';
import ImageWrapper from './ImageWrapper';

import { Box, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

type EmptyListPropsT = {
  background: 'default' | 'paper';
  message: string;
  delayMs?: number;
};

function EmptyState({ message, background, delayMs = 500 }: EmptyListPropsT) {
  const { palette } = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  if (!visible) return null;

  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          background === 'default'
            ? palette.background.default
            : palette.background.paper,
      }}
    >
      <ImageWrapper src={[emptyStateImage, emptyStateImage]} />
      <Typography variant="body1" align="center" color="textSecondary">
        {message}
      </Typography>
    </Box>
  );
}

EmptyState.defaultProps = {};

export default EmptyState;
